import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=8c3b716e&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=8c3b716e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3b716e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c3b716e')) {
      api.createRecord('8c3b716e', component.options)
    } else {
      api.reload('8c3b716e', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=8c3b716e&scoped=true&", function () {
      api.rerender('8c3b716e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IBCuvEpl5HYn/JS/comp/Voucher.vue"
export default component.exports